import React, { useState } from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import TransHook from "../../../hook/locale/trans-hook";
import logo from "../../../Assets/logo/Soon Kitchen Logo.png";
import "./Mheader.css";

const Mheader = () => {
  const [, , t] = TransHook();
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { display: t("home"), url: "/" },
    { display: t("aboutUs"), url: "/" },
    { display: t("Markalarımız"), url: "/Brands" },
    { display: "Franchise", url: "/franchise" },
    { display: "Menu", url: "/menu" },
    { display: "İletişim", url: "/" },
  ];

  return (
    <header className="mheader">
      <Container>
        <div className="mheader-navigation">
          {/* Logo */}
          <div className="mheader-logo">
            <Link to="/">
              <img src={logo} alt="Soon Kitchen" />
            </Link>
          </div>

          {/* Hamburger Icon */}
          <div
            className={`mheader-hamburger ${isOpen ? "open" : ""}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </Container>

      {/* Mobile Menu Overlay */}
      <div className={`mheader-overlay ${isOpen ? "active" : ""}`}>
        <nav className="mheader-menu">
          <ul>
            {navLinks.map((item, index) => (
              <li key={index} onClick={() => setIsOpen(false)}>
                <Link to={item.url}>{item.display}</Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Mheader;
